export const emailLink = {
  'Attendance confirmed!': 'Presença confirmada!',
  'Cancel session': 'Cancelar sessão',
  'Changed your mind? You can still confirm your attendance.':
    'Mudou de ideia? Você ainda pode confirmar sua presença.',
  'Confirm attendance': 'Confirmar presença',
  'Confirm your attendance': 'Confirme sua presença na sessão',
  'Do you really want to cancel your session?':
    'Deseja realmente cancelar sua sessão?',
  'Go to the website': 'Ir para o site',
  'Hi, {{name}}!': 'Olá, {{name}}!',
  'Invalid link': 'Link inválido',
  'Remember: not attending has the same effect as a cancellation and will also be counted as a completed session.':
    'Lembre-se: o não comparecimento tem o mesmo efeito do cancelamento e também será considerado sessão realizada.',
  'Session confirmation': 'Confirmação de sessão',
  'The session time has passed and this link is no longer valid. If you need help, contact your unit.':
    'O horário da sessão já passou e este link não é mais válido. Se precisar de ajuda, fale com a sua unidade.',
  'There was an error loading your session. Please try again.':
    'Não foi possível carregar sua sessão. Tente novamente.',
  'This link has expired': 'Este link expirou',
  'This session has already been cancelled.': 'Esta sessão já foi cancelada.',
  'This session has already been completed.': 'Esta sessão já foi finalizada.',
  'We could not find this session. Use the link from the latest confirmation email.':
    'Não encontramos esta sessão. Use o link do e-mail de confirmação mais recente.',
  'Your attendance is already confirmed.': 'Sua presença já está confirmada.',
  'Your session was cancelled.': 'Sua sessão foi cancelada.',
};
